import { request } from './http.js'

export async function fetchTop500Pool() {
  const data = await request('/api/top500-pool')
  return data.list || []
}

export async function fetchFocusStocks() {
  const data = await request('/api/focus-stocks')
  return data.list || []
}

export async function saveFocusStocks(codes) {
  const data = await request('/api/focus-stocks', {
    method: 'PUT',
    body: JSON.stringify({ codes }),
  })
  return data.list || []
}

export async function fetchStockTrend({ codes, start, end }) {
  const params = new URLSearchParams({ start, end })
  const list = Array.isArray(codes) ? codes : [codes]
  params.set('codes', list.filter(Boolean).join(','))
  return request(`/api/stock-trend?${params.toString()}`)
}
